import { FormControl, FormGroup } from '@angular/forms';
import { RetailActivityItem } from 'src/app/core/models/reports/retail-activity.model';

export const CONSTS = {
  HEADER: $localize`Retail Activity Report`,
  DATE_LABEL: $localize`Date`,
};

export const REPORT_FILE_NAME = 'Retail-Activity-Report';

export const PDF_REPORT = {
  NAME: $localize`RETAIL ACTIVITY`,
  HEADER: {
    LOCATION: $localize`Location` + ':',
    DATE: $localize`Date` + ':',
  },
  COLUMNS: [
    $localize`Trackno`.toUpperCase(),
    $localize`Event`.toUpperCase(),
    $localize`Time`.toUpperCase(),
    $localize`Received By`.toUpperCase(),
  ],
  DATA_FIELDS: [
    'trackNo',
    'event',
    'time',
    'receivedBy',
  ] as (keyof RetailActivityItem)[],
};

type RetailActivityFormField = {
  date: FormControl<Date>;
};

export type RetailActivityFormGroup = FormGroup<RetailActivityFormField> | null;
